export const VOUCHER_COMMON_BENEFITS = [
  `VOD 30만편 이상&lpar;방송/해외시리즈/키즈/애니메이션 등&rpar; 제공`,
  `LIVE 100개 이상 채널 시청`,
  `영화 6천편 무제한 시청&lpar;영화플러스 개별구매 별도&rpar;`,
  `다운로드 무제한 / QVOD / 타임머신 이용`,
]

export const VOUCHER_ANDROID_OS_NOTICE = [
  `오늘 결제 시  다음 달 정기결제 시점부터  Premium ₩16,000,\n Standard  ₩12,500, Basic ₩9,000이 매월 자동 결제됩니다.`,
  `Google Play 의 정기 결제 페이지에서 언제든지 취소 할 수 있습니다.`,
  `신규 할인 가격이 종료되기 7일 전에 알림을 드립니다.`,
]

// ios 서비스 이용 주의사항
export const CAUTIONS_FOR_SERVICE_IOS = [
  `Wavve 서비스는 국내 및 해외 서비스 대상 국가에서 이용하실 수 있습니다.`,
  `이용권 및 개별 구매 영화는 국내에서 결제 가능하고, 결제 후 해외 서비스 대상국가에서 모바일/태블릿 앱으로 (ios/Android) 7일간 시청할 수 있습니다.`,
  `일부 콘텐츠는 콘텐츠 제공사의 요청으로 해외 서비스 대상 국가에서도 이용이 불가합니다.`,
  `해외 서비스 대상 국가에서는 다운로드를 제공하지 않습니다.`,
  `해외 서비스 대상 국가 : 싱가폴, 인도네시아, 말레이시아, 필리핀, 베트남, 라오스, 태국`,
  `해외 서비스 대상 국가가 아닌 국가에서는 서비스 이용이 불가합니다.`,
  `프리미엄 이용권은 동시에 4명, 스텐다드 이용권은 2명이 동시에 시청할 수 있습니다. 베이직 이용권은 1명만 시청할 수 있습니다.`,
  `일부 콘텐츠는 콘텐츠 제공사의 요청으로 LIVE 및 VOD 서비스를 제공하지 않을 수 있습니다.`,
  `일부 콘텐츠는 콘텐츠 제공사의 요청으로 FHD 화질을 제공하지 않을 수 있습니다.`,
  `콘텐츠 및 서비스 사정에 따라 다운로드 및 다운로드 횟수가 제한될 수 있습니다.`,
  `TV 및 PC 에서는 다운로드가 불가합니다.`,
  `프리미엄 이용권은 일부 콘텐츠를 최고화질(4K UHD, Dolby, HDR)로 시청할 수 있습니다. 최고화질은 이용하는 기기의 사양, 네트워크 환경 등에 따라 변경될 수 있습니다.`,
  `이용 기기 중 TV 는 Wavve앱이 설치가 되어 있거나 앱스토어에서 설치가 가능한 스마트TV 및 Android TV 기기이며, TV에서는 일부 채널은 LIVE서비스를 제공하지 않습니다. LINK1__자세히보기__`,
  `TV에서는 콘텐츠제공사의 요청으로 LIVE 서비스를 제공하지 않습니다.`,
  `구형 smart TV에서 DRM콘텐츠 재생이 종료됨에 따라 서비스가 제공되지 않을 수 있습니다. LINK2__자세히보기__`,
  `자사의 콘텐츠 보호 정책에 따라 높은 등급의 보안 인증을 (Microsoft Playready SL3000 이상 / Google Widevine L1 이상 / Apple FairPlay) 받지 않은 기기이거나 HDCP 2.2 이상이 아닌 기기로 UHD(4K) 재생 시 낮은 화질(FHD 이하)로 재생될 수 있습니다.`,
]

// 서비스 이용 주의사항
export const CAUTIONS_FOR_SERVICE = [
  `Wavve 서비스는 국내 및 해외 일부 해외 서비스 대상 국가에서 이용하실 수 있습니다.`,
  `국내에서 결제완료된 콘텐츠에 한해 해외 서비스 대상국가 여행 시 모바일 앱(ios/Android)으로 7일간 스트리밍(재생) 서비스를 이용하실 수 있습니다.`,
  `해외 서비스 대상국가 : 싱가폴, 인도네시아, 말레이시아, 필리핀, 베트남, 라오스, 태국`,
  `해외 서비스 대상국가가 아닌 지역에서는 서비스 이용이 불가하며, 일부 콘텐츠는 콘텐츠제공사(CP)의 별도 요청, 저작권 문제, 기타 사업권역 문제 등으로 해외 서비스 이용이 제한될 수 있습니다.`,
  `동시접속 상품은 한 계정당 구매하신 회선만큼 동시에 여러 기기에서 시청하실 수 있는 상품입니다. 1회선 이용 시에는 동시접속이 차단됩니다.`,
  `일부 콘텐츠는 저작권자의 요청에 따라 LIVE 및 VOD 서비스가 제공되지 않을 수 있습니다.`,
  `자동결제 시 이용기간 중 결제 당일을 제외하고 언제든지 자동결제를 해지하실 수 있습니다.`,
  `다운로드 무제한 이용권은 모바일 기기에서만 무제한 다운 가능합니다.`,
  `FHD 이용권 구매 시 시범 서비스 기간동안 TV기기 및 OTT 기기에서 일부 콘텐츠를 UHD로 이용하실 수 있습니다.`,
  `기타 자세한 사항은 이용권 안내 페이지를 참고해 주세요.`,
  `이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가 가능합니다. 자세한 사항은 LINK1__'유료상품 이용약관'__ 제10조를 참조하시기 바랍니다.`,
  `이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분 환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한 경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)`,
  `이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브 LINK2__고객센터__에 연락해 주시기 바랍니다.`,
]

// ios 이용권 페이지 서비스 이용 권장사양
export const RECOMMENDATION_FOR_SERVICE_IOS = [`iOS 15 버전 이상`]
// 이용권 페이지 서비스 이용 권장사양
export const RECOMMENDATION_FOR_SERVICE = [
  `PC : Windows 10 이상, MacOS 10.12 이상. Chrome/Edge/Safari 등 HTML 5 지원 브라우저 최신 버전,\n스마트폰 : Android 11 버전 이상, iOS 15 버전 이상의 국내 출시 모델,\n태블릿 : Android 11 버전 이상, iOS 15 버전 이상의 국내 출시 모델,\nTV : 삼성 스마트TV Tizen 3.0 이상의 모델 / LG 스마트TV webOS 3.5이상의 모델\n`,
]

// 프로모션 텍스트 (usually changes)
export const PROMOTION_TEXT = [
  `12개월 이용권 할인 프로모션(41% 할인)은 2024.12.18 10:30 부터 2024.12.31 23:59까지 진행됩니다.`,
  `12개월 이용권 할인 프로모션 기간에 할인 상품 구매 시 첫 해에만 추가 할인 금액으로 결제되고, 12개월 후에는 기존 금액 (16% 할인)으로 연 1회 정기 결제됩니다.`,
]

// 이용권 구매 주의사항
export const CAUTIONS_FOR_PURCHASE = [
  `모든 이용권은 부가세(VAT) 포함 가격입니다.`,
  `이용권 가격은 변경될 수 있습니다.`,
  `Google Play 결제 금액은 PC/모바일웹 결제 금액과 상이합니다. LINK1__자세히보기__`,
  `자동결제는 1개월 주기로 매월 구매한 날과 동일한 날짜에 결제됩니다. 해당월에 동일한 날짜가 없으면 말일에 결제됩니다.`,
  `연간 이용권(12개월)의 경우 년1회 결제 구매한 날과 동일한 날짜에 결제되며, 해당 일자가 없는 경우 해당 월의 말일에 결제됩니다.`,
  `결제 당일을 제외한 이용기간 중 언제든지 자동결제를 해지하실 수 있습니다. 해지하면 더 이상 추가 결제되지 않으며, 다음 결제 예정일까지 서비스를 계속 이용할 수 있습니다. LINK2__구매내역 바로가기__`,
  `제휴 이용권은 할인한 가격이므로 추가 혜택(페이백, 기타 할인 등)을 제공하지 않습니다.`,
  `자동 결제 연동이 필요한 프로모션 쿠폰 사용 중에는 다른 할인 이벤트가 노출되지 않을 수 있으며, 구독 또한 불가합니다.`,
  `통신사, 신용카드 정보 변경 및 잔액부족 시에는 결제실패로 자동결제가 해지될 수 있습니다.`,
  `고객센터를 통한 자동결제해지 신청은 본인만 가능합니다.`,
  `이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가 가능합니다. 자세한 사항은 LINK3__'유료상품 이용약관'__제10조를 참조하시기 바랍니다.`,
  `12개월 이용권의 경우, 장기 이용에 대한 할인 혜택이 적용된 금액이므로 중도 해지 시에는 1개월 이용권 기준의 할인 미적용 정상가 기준으로 일할 계산하여 환불 금액이 정산되오니 유의 부탁드립니다.`,
  ...PROMOTION_TEXT,
  `이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분 환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한 경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)`,
  `이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브 LINK4__고객센터__에 연락해 주시기 바랍니다.`,
]

// ios 이용권 구매 주의사항
export const CAUTIONS_FOR_PURCHASE_IOS = [
  `모든 이용권은 부가세(VAT)포함 가격입니다.`,
  `상품 가격은 내부 정책으로 인해 변경 될 수 있습니다.`,
  `자동 결제 연동이 필요한 프로모션 쿠폰 사용 중에는 다른 할인 이벤트가 노출되지 않을 수 있으며, 구독 또한 불가합니다.`,
  `통신사, 신용카드 정보 변경 및 잔액부족 시에는 결제실패로 자동결제가 해지될 수 있습니다.`,
  `이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가 가능합니다. 자세한 사항은 LINK1__'유료상품 이용약관'__ 제10조를 참조하시기 바랍니다.`,
  `12개월 이용권의 경우, 장기 이용에 대한 할인 혜택이 적용된 금액이므로 중도 해지 시에는 1개월 이용권 기준의 할인 미적용 정상가 기준으로 일할 계산하여 환불 금액이 정산되오니 유의 부탁드립니다.`,
  `이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분 환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한 경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)`,
  `이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브 LINK2__고객센터에__ 연락해 주시기 바랍니다.`,
]

// ios App Store 결제 주의사항
export const CAUTIONS_FOR_PURCHASE_APP_STORE_IOS = [
  `App Store 결제는 iTunes 계정을 통해 원화로 진행됩니다.`,
  `해외원화결제(DCC)로 추가 수수료가 발생할 수 있습니다. (애플 고객센터: 080-333-4000)`,
  `App Store 결제는 1개월 단위로 이루어지므로 구매하신 날과 매월 동일한 날짜에 자동결제 됩니다.`,
  `자동결제 예정일 전 (최대) 24시간 이내에는 자동결제를 해지해도 결제 예정일에 결제가 이루어집니다.`,
  `결제 시 자동결제 예정일 전 (최대) 24시간 이내에 금액확인과 함께 결제됩니다.`,
  `App Store 자동결제 예정일과 실제 Wavve이용권 구매일/만료일 표기는 결제 시점, 구매 오류 후 구매 복원일, 시차 차이 등으로 인하여 다를 수 있습니다.`,
  `자동결제 해지 시 결제 예정일(최대 만료시간 24시간 전)을 제외한 이용기간 중 언제든지 자동결제를 해지하실 수 있습니다. 이 경우 더 이상 추가 결제되지 않으며 남은 기간 동안은 계속 이용하실 수 있습니다.`,
  `App Store 자동결제는 iTunes의 [계정설정 > 구독관리]에서 해지하실 수 있습니다.`,
]

export const CAUTIONS_FOR_SERVICE_LINK_APP = {
  LINK1: {
    href: '/customer/agreement?category=payment&isdeeplink=y',
    attr: null,
  },
  LINK2: {
    href: 'captvpooq://customer/qna/inquiry',
    attr: null,
  },
}

export const CAUTIONS_FOR_SERVICE_LINK_WEB = {
  LINK1: {
    href: '/customer/agreement?category=payment&isdeeplink=y',
    attr: null,
  },
  LINK2: {
    href: 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile',
    attr: null,
  },
}

export const CAUTIONS_FOR_SERVICE_LINK = {
  LINK1: {
    href: `/customer/faq?keyword=실시간 채널`,
    attr: null,
  },
  LINK2: {
    href: `/customer/notice_view?filterType=all&noticeId=2900`,
    attr: {
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  },
}

export const createCautionsForAndroidMoWeb = (pgName, device) => ({
  LINK1: {
    href: `/customer/notice_view/2865`,
    attr: null,
  },
  LINK2: {
    href: `/my/subscription_ticket?pgname=${pgName}&device=${device}`,
    attr: null,
  },
  LINK3: {
    href: `/customer/agreement?category=payment&isdeeplink=y`,
    attr: null,
  },
  LINK4: {
    href:
      device === 'mobile'
        ? 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile'
        : 'captvpooq://customer/qna/inquiry',
  },
})
